import accommodationList from './AccommodationList/es.json';
import chat from './Chat/es.json';
import common from './Common/es.json';
import consent from './Consent/es.json';
import forgotPassword from './ForgotPassword/es.json';
import main from './Main/es.json';
import signIn from './SignIn/es.json';
import signUp from './SignUp/es.json';
import transportList from './TransportList/es.json';

export default {
  accommodationList,
  chat,
  common,
  consent,
  forgotPassword,
  signIn,
  signUp,
  transportList,
  main
};
